import * as React from 'react';
import Accordion from 'src/app/Container/Accordion/Accordion';
import { ConfigurationHeader, ConfigurationPartProps, ConfigurationPart } from 'src/app/Partials';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationAssemblies.messages';

import {
  AssemblySelection,
  AssemblyAccessories,
  ElementNext,
} from 'src/app/Partials/Configuration/Inputs';

import { 
  GlobalPrivateState,
  NavigationConfigurationKeys,
  formatMessage,
  AssemblyAccessoriesKeys,
} from 'src/api';

import { 
  AssemblyAccessoriesDefaultModel,
  ConfigurationModel, 
} from 'franke-trough-dependencies';

import 'rc-slider/assets/index.css';
import './ConfigurationAssemblies.page.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationAssembliesPageProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  validated: GlobalPrivateState['validatedConfiguration'];
}

export class ConfigurationAssemblies extends React.Component<ConfigurationAssembliesPageProps> {
  componentDidMount() {
    this.dispatchDefaults();
  }

  public render() {
    return (
      <div className="page-configuration-assemblies">
        <div className="col-12">
          <ConfigurationHeader
            icon="wrench"
            title={formatMessage(MESSAGES.assemblyTitle)}
          />
        </div>
        <div className="configuration-wrap pl-5 pr-5 pt-1">
          <div className="col-12 pb-3 pl-0 pr-0">
            {this.props.configuration && this.props.configuration.result && (
              <Accordion>
                {this.assemblyParts.map((props, index) => {
                  const key = `configuration_assembly_${index}`;
                  return props ? (
                    <ConfigurationPart
                      key={key}
                      {...props}
                    />
                  ) : <React.Fragment key={key} />;
                })}
              </Accordion>
            )}
          </div>
          <div className="col-12 border-bottom pb-3 pl-0 mb-3">
            <small>
              <strong><FormattedMessage {...MESSAGES.configurationAssembliesNote} /></strong><br />
              {this.hasAssemblySelected ? (
                <FormattedMessage {...MESSAGES.configurationAssembliesNoteMessageWith} />
              ) : (
                <>
                  <FormattedMessage {...MESSAGES.configurationAssembliesNoteMessageWithout} />&nbsp;
                  {this.trough && !this.trough.preparedBackWallWith && <FormattedMessage {...MESSAGES.configurationAssembliesNoteMessageWithoutTriggerSafety} />}
                </>
              )}
            </small>
          </div>
          <div className="col-12 pt-4 text-center">
            <ElementNext id={NavigationConfigurationKeys.assemblyAccessories} />
          </div>
        </div>
      </div>
    );
  }

  private get hasAssemblySelected() {
    return this.props.configuration 
      && this.props.configuration.result 
      && this.props.configuration.result.assemblyAccessories 
      && this.props.configuration.result.assemblyAccessories.selection;
  }

  private get assemblyParts(): (ConfigurationPartProps | null)[] {
    const validated = this.props.validated.byItem.assemblyAccessories;
    return [{
      btnName: formatMessage(MESSAGES.assemblyBtnSelection),
      component: AssemblySelection,
      error: [validated && validated.selection || false],
      id: AssemblyAccessoriesKeys.Selection,
    }, this.props.configuration.result && this.props.configuration.result.assemblyAccessories && this.props.configuration.result.assemblyAccessories.selection === true ? {
      btnName: formatMessage(MESSAGES.assemblyBtnAssemblyAccessories),
      component: AssemblyAccessories,
      error: [validated && validated.console || false],
      id: AssemblyAccessoriesKeys.Console,
    } : null];
  }
     
  private get defaults(): AssemblyAccessoriesDefaultModel | undefined {
    const { configuration } = this.props;
    const confDefaults = configuration.result && configuration.result && configuration.result.defaults;
    return confDefaults && confDefaults.assemblyAccessories;
  }

  private get trough() { 
    return this.props.configuration.result && this.props.configuration.result.selectedTrough && this.props.configuration.result.selectedTrough.trough;
  }

  private dispatchDefaults() {
    const { configuration } = this.props;
    
    if (!isConfigurationEditable()) { return; }

    if (configuration && configuration.result && !configuration.result.assemblyAccessories) {
      const defaults = this.defaults;
      if (defaults) {
        const data: ConfigurationModel['assemblyAccessories'] = {
          selection: defaults.selection.default,
          console: defaults.console.default || 'stainlessSteel',
          acceptedMiranitOverlap: defaults.acceptedMiranitOverlap.default
        };

        this.props.dispatch(requestAPIActions.load(
          'configuration',
          {
            url: `/Configurations/${configuration.result.id}`,
            options: {
              method: 'PATCH',
              data: {assemblyAccessories: data},
            },
          },
          true
        ));
      }
    }
  }
}

export const ConfigurationAssembliesPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  validated: state.validatedConfiguration,
}))(ConfigurationAssemblies);

export default ConfigurationAssembliesPage;